<template>
  <div id="privacy" class="page page--content">
    <div class="container">
      <v-section v-if="privacy.text">
        <v-rich-text :content="privacy.text"/>
      </v-section>
    </div>
  </div>
</template>

<script>
import query from '@/services/api/query';

export default {
  name: 'Privacy',
  data() {
    return {
      privacy: {},
    };
  },
  methods: {
    showCookieNotice() {
      this.$eventBus.$emit(this.$events('GLOBAL.SHOW_TRACKING_NOTICE'))
    }
  },
  created() {
    window.showCookieNotice = this.showCookieNotice;
  },
  apollo: {
    privacy: query.privacy,
  },
  components: {
    vSection: () => import('@/components/section'),
    vRichText: () => import('@/components/rich-text'),
  },
};
</script>
